import { useCallback } from 'react';
import type { ICatalog } from '@platform/core/types';
import { useAppSelector } from '@platform/state/hooks';
import { selectLang } from '@platform/state/selectors';
import { moduleDescription } from './moduleDescription';
import { useLoadedModuleStrings } from './useLoadedModuleStrings';

/**
 * Описи модулів для плиток оболонки (прототип v4 mm.desc): довантажує рядки пакетів названих модулів і повертає функцію «ключ → опис»
 * (до завантаження — гасло каталогу). Після завантаження функція отримує нову тотожність.
 */
export function useModuleDescriptions(catalog: ICatalog | undefined, keys: readonly string[]): (key: string) => string {
  const lang = useAppSelector(selectLang);
  const version = useLoadedModuleStrings(keys);
  return useCallback(
    (key: string) => moduleDescription(catalog?.modules.find((m) => m.key === key.split('/')[0]), lang),
    // eslint-disable-next-line react-hooks/exhaustive-deps -- version: нова тотожність після довантаження пакетів
    [catalog, lang, version],
  );
}
